export enum NotificationActionType {
  OpenPanel = 'OPEN PANEL',
  ClosePanel = 'CLOSE PANEL'
}
